import { createContext } from "react";
import { IFailureDetailsSettingsContext } from "./FailureDetailsSettingsInterfaces";

export const initialState: IFailureDetailsSettingsContext = {
    selectedFailureTypeId: null,
    selectedFailureCodeId: null,
    selectedAreaId: null,
    selectedFunctionalLocationId: null,
    selectedSecondaryFunctionalLocationId: null,
    isSelectedFailureTypeLocationSpecific: null,
    handleSelectedFailureTypeId: () => {},
    handleSelectedFailureCodeId: () => {},
    handleSelectedAreaId: () => {},
    handleSelectedFunctionalLocationId: () => {},
    handleSelectedSecondaryFunctionalLocationId: () => {},
    handleIsSelectedFailureTypeLocationSpecific: () => {},
};

export const FailureDetailsSettingsContext = createContext(initialState);
